import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class EntityInvest extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {

            // 企业对外投资信息
            options:{
                'url':url,
                'records':5,
                'title':'企业对外投资信息'
            },
            columns:[
                {name:'ENTNAME', title:'被投企业名称', type:'string'},
                // {name:'NAME', title:'被投企业法定代表人', type:'string'},//无
                // {name:'REGORG', title:'被投企业登记机关', type:'string'},//无
                // {name:'ENTTYPE', title:'被投企业类型', type:'string'},//无
                {name:'ESTDATE', title:'被投企业成立日期', type:'string'},
                {name:'REGSTATE', title:'被投企业经营状态', type:'string' },
                // {name:'REGCAP', title:'被投企业注册资本（万元）', type:'string'},
                // {name:'REGCAPCUR', title:'被投企业注册资本币种', type:'string'},//无
                {name:'SUBCONAM', title:'认缴出资额', type:'string'},
                // {name:'SUBCONCUR', title:'认缴出资币种', type:'string'},//无
                {name:'SUBCONPROP', title:'出资比例', type:'string', properties: { transform: "transformSUBCONPROP"}},
                // {name:'SUBCONFORM', title:'认缴出方式', type:'string'},//无
                // {name:'ESTDATE', title:'成立日期', type:'date'},
            ],
            params :{
                'service':'getForinvestmentInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //分支机构
            options2:{
                'url':url,
                'records':5,
                'title':'分支机构'
            },
            columns2:[
                {name:'ENTNAME', title:'分支机构名称', type:'string'},
                {name:'DISTRICT', title:'所属省份', type:'string'},
                {name:'REGSTATE', title:'经营状态', type:'int'},
                {name:'ESTDATE', title:'成立日期', type:'string'},
            ],
            params2 :{
                'service':'getBranchInfo',
                'user':UID,
                'ENTNAME' : entname
            },
        };

        this.onLoadToken = this.onLoadToken.bind(this);
        this.notify = this.notify.bind(this);
        

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params, params2 } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
            params2["access"] =  result.result.token;
   
            this.setState({
                params:params,
                params2:params2,
            }); 
        } 
        else
        {
            return ;
        }  
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            this.state["params2"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    change( item )
    {
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }
        item.target.className = 'title-label title-label-active';

        let e = document.getElementById(item.currentTarget.id.substring(1));
        e.scrollIntoView({behavior:'smooth'}); 
    }

    notify(type, data, value)
    {
        if( type==="transformSUBCONPROP" )
        {
            if( data.SUBCONPROP!==undefined && data.SUBCONPROP!==null && data.SUBCONPROP!=="")
            {
                let ret = data.SUBCONPROP*100;

                if( Number.isInteger(ret))
                {
                    return ret + "%";
                }
                else
                {
                    return Widget.numberFormatter(ret, 2) + "%";
                }
               
            }
            else
            {
                return "";
            }
        }
    }

    render() 
	{

        const { options, columns, params, options2, columns2, params2 } = this.state;
        
        return(
            <div className="page">
                {/* label */}
                {/* <div className="page-weidu entity-title">
                    <div id="0outInvest" className="title-label title-label-active" onClick={this.change.bind(this)}>企业对外投资信息</div>
                    <div id="0branchOrg" className="title-label " onClick={this.change.bind(this)}>分支机构</div>
                </div> */}

                <div className="page-content page-overflow page-content-custom white padding-20">
                    {/* 企业对外投资信息 */}
                    <div id="outInvest" className="content-top content-canvas-custom border-top-left-radius-0">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} notify={ this.notify} />
                    </div>

                    {/* 分支机构 */}
                    <div id="branchOrg" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options2} columns={columns2} params={params2} notify={ this.notify} />
                    </div>
                </div>
            </div>
        );
    }

}

export default EntityInvest